import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M726.048 74.016c12.512 12.512 13.248 31.872 2.048 43.776l-376.48 376.512c-16.16 15.328-16.096 19.328 0 35.424l376.48 376.448c11.232 11.904 10.464 31.264-2.048 43.776-12.736 12.736-32.608 13.44-44.448 1.632L263.424 533.408c-5.152-5.152-7.456-11.84-7.872-18.784v-5.248c.448-6.944 2.752-13.632 7.872-18.784L681.6 72.384c11.84-11.776 31.744-11.072 44.448 1.632z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol